// Module
var code = "<div id=\"V-2E0E1345-9656-4075-87F7-BFF4A84753DC\" style=\"background-color:#7fffd4\"> <h3>Chart</h3> </div> ";
// Exports
export default code;